import CONST from "./config/CONST";

// === REACT STUFF === //
// import 'react-app-polyfill/ie11';
// import "core-js"; // Babel polyfill for IE11
import React, {Suspense, lazy, useEffect} from 'react';
import { render } from "react-dom";
import { ParallaxProvider } from 'react-scroll-parallax';
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import AppLoader from "./components/AppLoader/AppLoader";

import './i18n';
import GlobalStyle from "./components/GlobalStyle";

// === COMPONENTS === //
const Header = lazy(() => import('./components/Menus/Header'));
const Container = lazy(() => import('./components/Container/Container'));
const Footer = lazy(() => import('./components/Menus/Footer'));

// === RESOURCES === //
import "./scss/custom-animate/animate.scss";
import store from "./store/store";
import {Provider, useDispatch} from "react-redux";
import {setIsPreview} from "./store/slices/previewSlice";
import {setIsWebpSupported} from "./store/slices/webpSupportSlice";


if(CONST.DEBUG) {
    console.log("CONST", CONST);
}

// const queryClient = new QueryClient();
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 60 * 60 * 1000,  // 1 hour
            refetchOnWindowFocus: false,
        },
    },
})

const AppWrapper = (props) => {
    return (
        <Provider store={store}>
            <App isPreview={props.isPreview} isWebpSupported={props.isWebpSupported} />
        </Provider>
    );
}


const App = (props) => {

    const basename = props.isPreview ? "/preview" : "";

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setIsPreview(!!props.isPreview));
        dispatch(setIsWebpSupported(!!props.isWebpSupported));
    }, []);

    return (
        <>
            <GlobalStyle />
            <ParallaxProvider>
                <QueryClientProvider client={queryClient}>
                    <ReactQueryDevtools initialIsOpen={false} />
                    <Router basename={ basename }>
                        <Suspense fallback={<AppLoader />}>
                            <Header />
                            <Container />
                            <Footer />
                        </Suspense>
                    </Router>
                </QueryClientProvider>
            </ParallaxProvider>
        </>
    )
};

function WebpIsSupported(callback){
    // If the browser doesn't has the method createImageBitmap, you can't display webp format
    if(!window.createImageBitmap){
        callback(false);
        return;
    }

    // Base64 representation of a white point image
    const webpdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

    // Retrieve the Image in Blob Format
    fetch(webpdata).then(function(response){
        return response.blob();
    }).then(function(blob){
        // If the createImageBitmap method succeeds, return true, otherwise false
        createImageBitmap(blob).then(function(){
            callback(true);
        }, function(){
            callback(false);
        });
    });
}

WebpIsSupported(function(isSupported){

    const rootEl = document.getElementById("root");
    const isPreview = !!rootEl.getAttribute('data-preview');

    window.isWebpSupported = isSupported;

    render(
        <AppWrapper
            isPreview={isPreview}
            isWebpSupported={isSupported}
        />
        , rootEl
    );

});

